import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'

const BannerButton = ({
  btnProps = {},
  productRef = undefined
}) => {
  const { label, link, pageId, variant } = btnProps

  const scrollToProductRef = () => {
    if (productRef) {
      window.scrollTo(0, productRef.current.offsetTop - 90)
    }
  }

  const getBtnVariant = () => {
    switch (variant) {
      case 'gray': return 'secondary border'

      case 'green': return 'success fw-500'

      case 'pink': return 'primary'

      case 'light': return 'light'

      default: return 'secondary border'
    }
  }

  const btnVariant = getBtnVariant()

  if (link?.length > 0 && !pageId?.urlId) {
    return (
      <a
        href={link}
        className={`btn d-flex align-items-center px-md-4 more-info-btn btn-sm btn-${btnVariant}`}
        target="_blank"
        rel="noreferrer"
      >
        {label}
        <i className="material-icons ms-2 h3 mb-0 d-lg-none d-xl-block line-1">
          arrow_right_alt
        </i>
      </a>
    )
  }

  if (!(link?.length > 0) && pageId?.urlId) {
    return (
      <Link
        to={getPath(pageId?.urlId)}
        className={`d-flex align-items-center px-md-4 more-info-btn btn  btn-sm btn-${btnVariant}`}
      >
        {label}
        <i className="material-icons ms-2 h3 mb-0 d-lg-none d-xl-block line-1">
          arrow_right_alt
        </i>
      </Link>
    )
  }

  return (
    <Button
      onClick={() => scrollToProductRef()}
      variant={btnVariant}
      size="sm"
      className="d-flex align-items-center px-md-4 more-info-btn"
    >
      {label}
      <i className="material-icons ms-2 h3 mb-0 d-lg-none d-xl-block line-1">
        arrow_right_alt
      </i>
    </Button>
  )
}

BannerButton.propTypes = {
  btnProps: PropTypes.instanceOf(Object),
  productRef: PropTypes.instanceOf(Object)
}

export default BannerButton
